// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__F0hBb","upload":"Small_upload__34FXQ","imageWrap":"Small_imageWrap__2zlMH","removeBtn":"Small_removeBtn__PaTTc"};